import React from "react";
import {connect} from "react-redux";
import Datetime from "react-datetime";
import {get, getAPIUrl} from "../../utils/api";
import 'react-datetime/css/react-datetime.css';
import './Export.css';
import moment from 'moment';
import AccessControl from "../../utils/AccessControl";
import calendar from "../../assets/reports/cal.png";
import whiteDownload from "../../assets/reports/whiteDownloadIcon.png";
import blueDownload from "../../assets/reports/blueDownloadIcon.png";

class Report extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            from_date: false,
            from_date_format: false,
            to_date: false,
            to_date_format: false,
            report: "",
            prevReports: []
        };

        this.handleDateChange = this.handleDateChange.bind(this);
        this.getDownloadUrl = this.getDownloadUrl.bind(this);
        this.handleDownloadClick = this.handleDownloadClick.bind(this);
        this.clearDates = this.clearDates.bind(this);
        this.reportChange = this.reportChange.bind(this);
    }
    componentDidMount() {
        this.getPrevReports();
    }

    getPrevReports = () => {
        return get('report/prevReports')
            .then((res) => {
                this.setState({
                    prevReports: res
                })
            })
    }

    reportChange(event) {
        this.setState({
            report: event.target.value
        })
    }
    handleDateChange(moment, name) {
        if (typeof moment.format === 'function') {
            let inputValues = Object.assign({}, this.state.inputValues);
            inputValues[name] = moment;
            inputValues[name + '_format'] = moment.format('MMMM YYYY');
            if(name === 'to_date'){
                inputValues[name + '_format'] = moment.endOf('month').format('MMMM YYYY');
            }
            if (name === 'from_date') {
                inputValues['to_date'] = false;
                inputValues['to_date_format'] = false;
            }
            this.setState({
                ...inputValues
            });
        }
    }

    handleDownloadClick(e) {
        e.preventDefault();
        window.open(this.getDownloadUrl(), '_blank');
        let self = this;
        setTimeout(function () {
            self.getPrevReports();
        }, 1000)

    }

    getDownloadUrl() {
        let url = getAPIUrl() + "/report";
        if (this.state.report) {
            url += this.state.report
        }
        url += '?';
        if (this.state.from_date !== false && this.state.from_date !== '') {
            url += 'start_date=' + this.state.from_date.format('YYYY-MM-DD');
        }
        if (this.state.to_date !== false && this.state.to_date !== '') {
            url += '&end_date=' + this.state.to_date.format('YYYY-MM-DD');
        }
        return url;
    }

    clearDates() {
      this.setState({
          from_date: false,
          from_date_format: false,
          to_date: false,
          to_date_format: false,
      });
    }
    formatUrl= (data) => {
        let apiUrl = getAPIUrl() + 'report';
        let url = "";
        if(data.report_type === "Best in Class"){
            apiUrl  += '/bic'
        }
        if(data.report_type === "D&A Report"){
            apiUrl  += '/da';
        }
        return apiUrl += '?start_date=' + moment(data.start_date).format('YYYY-MM-DD') + '&end_date=' +  moment(data.end_date).endOf('month').format('YYYY-MM-DD');
    }

    render() {
        const dateToStore = '2016-09-01 12:00';
        const momentDate = moment(dateToStore, 'YYYY-MM-DD HH:mm');

        var valid = function (current) {
            return current.isAfter(momentDate);
        };

        var validEndDate = (current) => {
            return current.isAfter(this.state.from_date);
        };

        return (
            <React.Fragment>
                <h3 className="export-title">Export Reports</h3>
            <div className="export-info-container">
                <div className="export-row">
                    <div className="export-column export-end">
                        <label>Start Date</label>
                        <Datetime
                            dateFormat={"MMMM YYYY"}
                            value={this.state.from_date_format}
                            className="form-control"
                            name="from_date"
                            onChange={moment => this.handleDateChange(moment, 'from_date')}
                            inputProps={{readOnly: true}}
                            closeOnSelect={true}
                            isValidDate={valid}
                        />
                        <div className="report-icons cal"><img src={calendar} alt=""/></div>
                    </div>
                    <div className="export-column export-end">
                        <label>End Date</label>
                        <Datetime
                            dateFormat={"MMMM YYYY"}
                            value={this.state.to_date_format}
                            className="form-control"
                            name="to_date"
                            onChange={moment => this.handleDateChange(moment, 'to_date')}
                            inputProps={{readOnly: true}}
                            closeOnSelect={true}
                            isValidDate={validEndDate}
                        />
                        <div className="report-icons cal"><img src={calendar} alt=""/></div>
                    </div>
                    <div className="export-column report-type">
                        <label>Report Type</label>
                        <div className="report-select-container">
                            <select name="report" className="select--report" onChange={this.reportChange}>
                                <AccessControl
                                    userPermissions={this.props.user.roles}
                                    allowedPermissions={['admin', 'analytics']}>
                                    <option value="">Creative Report</option>
                                    <option value="/da">D&A Report</option>
                                </AccessControl>
                                <AccessControl
                                    userPermissions={this.props.user.roles}
                                    allowedPermissions={['admin', 'editor']}>
                                <option value="/bic">Best in Class</option>
                                </AccessControl>
                            </select>
                        </div>
                    </div>
                    <div className="export-column export-type">
                        <label>Export As</label>
                        <div className="export-radio-btn-container">
                            <p>Excel</p>
                            {/*<input type="radio" name="excel" id="excel" className="select--report"/>*/}
                        </div>

                    </div>
                    <div className="export-btn-containers">
                        <button className="clear-button" onClick={this.clearDates}>Clear Dates</button> <a className="button button--blue report-download-btn" href={this.getDownloadUrl()} onClick={(e) => this.handleDownloadClick(e)}><div className="report-icons down-arrow"><img src={whiteDownload} alt=""/></div>Download</a>
                    </div>
                </div>
            </div>
                <div className="prev-reports-container">
                    <h4>Previously Exported Reports</h4>
                    <div className='prev-reports-results'>
                        <table className="table report-table">
                            <thead>
                            <tr>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Report Type</th>
                                <th>File Type</th>
                            </tr>
                            </thead>
                            {this.state.prevReports.length > 0 &&
                                <tbody>
                                    {this.state.prevReports.map((row, key) => (
                                        <tr key={key}>
                                            <td>{row.start_date}</td>
                                            <td>{row.end_date}</td>
                                            <td>{row.report_type}</td>
                                            <td>{row.file_type}</td>
                                            <td><a href={this.formatUrl(row)} target="_blank" className='download-link' style={{'color': '#6BB2C4'}}><div className="report-icons down-arrow"><img src={blueDownload} alt=""/></div>Download</a></td>
                                        </tr>
                                    ))}
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps)(Report);
